import { posToDOMRect } from '@tiptap/core';
import { DataCollectionSmall } from '@wix/wix-ui-icons-common';

import {
  type EditorPluginCreator,
  quickActionsModalSections,
  RicosPluginToolbarNames,
} from './../ricos-types';
import { changeSelectionToEndOfTextBlock } from './../wix-rich-content-common';

import { DEFAULTS } from './defaults';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { InsertModal } from './modals/InsertModal';
import { shortcuts } from './shortcuts';
import { tableCellConverter, tableConverter, tableRowConverter } from './table-converters';
import { tiptapExtensions } from './tiptap/tiptap';
import type { TablePluginEditorConfig } from './types';
import { INSERT_TABLE_MODAL_ID, TABLE_TYPE } from './types';

export const pluginTable: EditorPluginCreator<
  TablePluginEditorConfig,
  { InsertModal: typeof InsertModal }
> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: TABLE_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [tableConverter, tableRowConverter, tableCellConverter],
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [
        RicosPluginToolbarNames.TABLE,
        RicosPluginToolbarNames.TABLE_CELL,
        RicosPluginToolbarNames.TABLE_ROW,
      ],
      getButtons: getToolbarButtons,
      isVisible: selection => 'jsonID' in selection && selection.jsonID === 'cell',
    },
    getQuickActions: ({ pluginServices }) => [
      {
        id: 'table',
        title: 'QuickActionsPlugin_ActionTitle_Table',
        icon: DataCollectionSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ['grid', 'chart', 'data', 'spreadsheet', 'matrix', 'rows and columns'],
        command: ({ modalService, editor }) => {
          changeSelectionToEndOfTextBlock(editor);

          modalService.togglePluginPanel({
            id: INSERT_TABLE_MODAL_ID,
            Component: InsertModal,
            componentProps: {},
            isMobile: pluginServices?.context.isMobile,
            positioning: {
              referenceElement: {
                getBoundingClientRect: () =>
                  posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  ),
              },
              placement: 'bottom-end',
            },
            mobileLayout: 'drawer',
          });
        },
      },
    ],
    shortcuts,
    __exports: { InsertModal },
  };
};
